import { render, staticRenderFns } from "./suitch-camera.vue?vue&type=template&id=0d588e27&"
import script from "./suitch-camera.vue?vue&type=script&lang=js&"
export * from "./suitch-camera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports